"use strict";

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import classnames from "classnames";

var projectPosition = function projectPosition(value, min, max) {
  return (value - min) / (max - min) * 100;
};

var projectRange = function projectRange(start, end, min, max) {
  return (end - start) / (max - min) * 100;
};

var GaugeRange = function GaugeRange(_ref) {
  var range = _ref.range,
      status = _ref.status,
      min = _ref.min,
      max = _ref.max;
  var start = range[0],
      end = range[1];

  var position = projectPosition(start, min, max);
  var width = projectRange(start, end, min, max);

  var gaugeRangeStyle = {
    left: position + "%",
    width: width + "%"
  };

  return _react2.default.createElement("div", { style: gaugeRangeStyle, className: "apl-gauge__range--" + status });
};

var Gauge = function Gauge(_ref2) {
  var min = _ref2.min,
      max = _ref2.max,
      value = _ref2.value,
      ranges = _ref2.ranges,
      showMinMax = _ref2.showMinMax;

  var position = projectPosition(value, min, max);
  var valueStyle = { left: position + "%" };
  var uniqueId = 0;

  return _react2.default.createElement(
    "div",
    { className: "apl-gauge" },
    showMinMax ? _react2.default.createElement(
      "div",
      { className: "apl-gauge__min" },
      min
    ) : null,
    _react2.default.createElement("div", { className: "apl-gauge__value", style: valueStyle }),
    showMinMax ? _react2.default.createElement(
      "div",
      { className: "apl-gauge__max" },
      max
    ) : null,
    _react2.default.createElement(
      "div",
      { className: "apl-gauge__ranges" },
      ranges.map(function (item) {
        return _react2.default.createElement(GaugeRange, _extends({}, item, { key: uniqueId += 1, min: min, max: max }));
      })
    )
  );
};

exports.default = Gauge;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/lib/components/gauge/gauge.js
// module id = 1384
// module chunks = 249